import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { ConnectionType } from '../store/schema/ConnectionType';
import { default as BasicAuthenticationOptions, } from './BasicAuthenticationOptions';
var styles = require('./IncomingServerInformation.scss');
var IncomingServerInformation = /** @class */ (function (_super) {
    tslib_1.__extends(IncomingServerInformation, _super);
    function IncomingServerInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLeaveCopyChanged = function (ev, checked) {
            _this.props.onUpdateLeaveCopy(checked);
        };
        _this.onRemoteSendChanged = function (option, evt) {
            _this.props.onUpdateRemoteSend(option.key === 'RemoteSend');
        };
        _this.renderImapServerContent = function () {
            return (_this.props.connectionType === ConnectionType.ImapSmtp && (React.createElement("div", null,
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_imapServerTextField, value: _this.props.incomingServer, onChanged: _this.props.onUpdateIncomingServer }),
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_incomingPortTextField, value: _this.props.incomingPort, onChanged: _this.props.onUpdateIncomingPort }))));
        };
        _this.renderPopServerContent = function () {
            return (_this.props.connectionType === ConnectionType.PopSmtp && (React.createElement("div", null,
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_popServerTextField, value: _this.props.incomingServer, onChanged: _this.props.onUpdateIncomingServer }),
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_incomingPortTextField, value: _this.props.incomingPort, onChanged: _this.props.onUpdateIncomingPort }),
                React.createElement(Checkbox, { className: styles.checkbox, label: strings.options_connected_advanced_leaveCopyCheckbox, defaultChecked: _this.props.leaveCopy, onChange: _this.onLeaveCopyChanged, disabled: _this.props.leaveCopyDisabled }))));
        };
        _this.renderRemoteSendContent = function () {
            return (_this.props.renderRemoteSend && (React.createElement(ChoiceGroup, { options: [
                    {
                        key: 'RemoteSend',
                        text: strings.options_connected_advanced_remoteSendOption,
                        checked: _this.props.remoteSend,
                    },
                    {
                        key: 'LocalSend',
                        text: strings.options_connected_advanced_localSendOption,
                        checked: !_this.props.remoteSend,
                    },
                ], className: styles.options, required: true, onChanged: _this.onRemoteSendChanged })));
        };
        return _this;
    }
    IncomingServerInformation.prototype.render = function () {
        return (React.createElement("div", null,
            this.renderImapServerContent(),
            this.renderPopServerContent(),
            this.props.isBasicAuth && (React.createElement(BasicAuthenticationOptions, tslib_1.__assign({}, this.props.basicAuthProps))),
            this.renderRemoteSendContent()));
    };
    IncomingServerInformation = tslib_1.__decorate([
        observer
    ], IncomingServerInformation);
    return IncomingServerInformation;
}(React.Component));
export default IncomingServerInformation;
//# sourceMappingURL=IncomingServerInformation.js.map